import React, { useState, useContext, useEffect } from 'react';
import Panel from '../../../../components/Panel';
import useAPI from '../../../../hooks/useAPI';
import useErrors from '../../../../hooks/useErrors';
import AuthContext from '../../../../contexts/AuthContext';
import ComponentBusy from '../../../../components/ComponentBusy';

export default function ContractDetails ({ onLoad, onLoadEnd }) {
    const { system } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [contractURI, setContractURI] = useState(null);

    const api = useAPI();
    const _errors = useErrors();

    const load = ()=>{
        onLoad();
        setLoading(true);
        
        api.json('GET',  '/systems/' + system.id + '/contract-summary')
           .then(r=>r.json())
           .then((r)=>{
              if(r.errors){
                _errors(r.errors);
                return;
              }
              if(r.data && r.data.contract_uri){
                setContractURI(r.data.contract_uri);
              }
           })
           .catch(e=>alert(e))
           .then(()=>{
                onLoadEnd();
                setLoading(false);
            })
    }

    useEffect(()=>{
        load();
        // eslint-disable-next-line
    }, []);

    if (loading) {
        return <ComponentBusy />;
    }

    return (
        <div className='account-settings'>
            <Panel
                title="Contract Details"
                contentStyle={{
                    padding: 20,
                }}
                headerStyle={{
                    borderBottomWidth: 1,
                    borderStyle: 'solid',
                    borderColor: '#E2E3E8',
                    padding: 20
                }}
            >
                <div className='row'>
                    <div className='col-12'>
                        {!contractURI ? (
                            <div style={{ display: 'flex', padding: 40, flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                                <span>No contract details available</span>
                            </div>
                        ) : (
                            <iframe src={contractURI} style={{ width: '100%', minHeight: 600 }} title="Contract Details Frame" />
                        )}
                    </div>
                </div>
            </Panel>
        </div>
    );
};